import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import img_all from '../../assets/all.png'
import img_coupon from '../../assets/coupon.png'
import img_live from '../../assets/live.png'
// import img_shop from '../../assets/shop.png'
import { styled } from '@mui/material';
import { useAlert } from '../AlertProvider/AlertProvider';


const actions = [
  { icon: <img src={img_coupon} alt="Coupon" style={{ width: '100%', height: 'auto' }} />, name: 'Coupon' },
  { icon: <img src={img_live} alt="Live" style={{ width: '100%', height: 'auto' }} />, name: 'Live' },
  // { icon: <img src={img_shop} alt="Shop" style={{ width: '100%', height: '100%' }} />, name: 'Shop' },
];



const customActionStyles = {
  width: '45px', // Desired width
  height: '45px', // Desired height
  background:'none',
  // '& img': {
  //   width: '50px', // Adjust icon width as needed
  //   height: '50px', // Adjust icon height as needed
  // },
   // Hide the circular button
   '& .MuiFab-root': {
    display: 'none',
  },
  '& .MuiTouchRipple-root': {
    display: 'none',
  },
};

const CustomIcon = styled('img')({
  width: '88%',
  marginLeft:'-6px',
  marginTop:'0px',
  height: 'auto',
});

export default function BasicSpeedDial() {

  const showAlert = useAlert();
  const clickHandler = (name) => {
    showAlert(`敬请期待`);
  }

  return (
    <Box sx={{ position: 'relative', height: '90px', transform: 'translateZ(0px)' }}>
      <SpeedDial
        direction='right'
        ariaLabel="SpeedDial basic example"
        icon={<CustomIcon src={img_all} />}
        sx={{
          position: 'absolute', left: '0px', top: '20px',
          '& .MuiSpeedDial-fab': {
            background:'none',
            boxShadow: 'none',
            '&:hover': {
              background:'none',
              boxShadow: 'none',
            },
          },
        }}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={() => clickHandler(action.name)}
            sx={customActionStyles}
          />
        ))}
      </SpeedDial>
    </Box>
  );
}